import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Carousel } from 'react-responsive-carousel';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';
import { ProfileMediaCounter } from 'components/shared/ProfileMediaCounter';
import { Popup } from 'components/UI/Popup';

import { getCarouselPopupImgs } from '../../utils';

import css from './transferUserPopupCarousel.module.sass';

type PropTypes = {
  onMount?: () => void;
  onClose: () => void;
  onSubmit: () => void;
};

export const TransferUserPopupCarousel: React.FC<PropTypes> = ({
  onMount,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation('app');

  useEffect(() => {
    onMount && onMount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Popup isIndented={false} onClose={onClose}>
      <div className={css.carouselHolder}>
        <Carousel
          showArrows={false}
          showThumbs={false}
          showIndicators
          infiniteLoop
          autoPlay
          // @ts-ignore
          statusFormatter={(current, total) => (
            <ProfileMediaCounter total={total} />
          )}
          className={css.carousel}
        >
          {getCarouselPopupImgs().map((img) => {
            return (
              <img
                key={img}
                src={img}
                width="355"
                height="319"
                className={css.photo}
                alt=""
              />
            );
          })}
        </Carousel>
        <div className={css.info}>
          <p className={css.name}>Gloria,22</p>
          <p className={css.location}>Birmingham, UK</p>
        </div>
      </div>
      <div className={css.content}>
        <h2 className={css.title}>
          <Trans i18nKey="transferUserPopup.title" ns="app" />
        </h2>
        <BaseButton type={ButtonTypes.Accent} onClick={onSubmit}>
          {t('transferUserPopup.submitBtn')}
        </BaseButton>
      </div>
    </Popup>
  );
};
